import { useRouteMatch } from 'react-router-dom';

const supportedLanguages = {
  en: "en",
  es: "es",
};

const useLanguage = () => {
  const match = useRouteMatch("/:lang/")
  const lang = match?.params?.lang;
  // Default is english
  const language = lang === supportedLanguages.es ? supportedLanguages.es : supportedLanguages.en;

  return language;
};
export { useLanguage, supportedLanguages }
